<template>
  <v-container class="h-100 pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="600">
        <v-img class="mx-auto mb-4" :src="LOGO_HEADER" contain />
        <div class="text-h5 text-center mb-8 font-weight-medium">Log into your account</div>
        <v-form v-model="isFormValid" @submit.prevent="onSubmit">
          <v-sheet class="border-opacity-25 border-thin rounded-lg overflow-hidden pa-5">
            <v-text-field
              v-model="loginForm.username"
              label="Email"
              placeholder="Email"
              class="rounded-lg"
              autocomplete="username"
              style="padding-right: 36px"
              :rules="[rules.required]" />
            <v-divider></v-divider>
            <v-text-field
              v-model="loginForm.password"
              label="Password"
              placeholder="Password"
              class="rounded-lg"
              autocomplete="current-password"
              :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showpassword ? 'text' : 'password'"
              :rules="[rules.required]"
              @click:append="showpassword = !showpassword" />
            <v-alert v-if="errors.apiError" type="error" class="mt-3"
              >{{ errors.apiError }}
            </v-alert>
            <div v-if="showValidationResend">
              <v-btn
                block
                class="rounded-lg mb-8 bg-blue"
                elevation="2"
                variant="text"
                @click="resendEmail"
                >Resend Validation Email</v-btn
              >
            </div>
          </v-sheet>
          <div class="py-4">
            <div class="d-flex justify-space-between align-center">
              <router-link
                class="text-decoration-none text-primary text-body-2 font-weight-medium"
                :to="{ name: 'ForgotPassword' }">
                Forgot password?
              </router-link>
            </div>
          </div>

          <FullWidthButton :disabled="!isFormValid" type="submit">Log In</FullWidthButton>
        </v-form>
        <div class="text-center text-body-2">
          Don't have an account?
          <router-link
            :to="{ name: 'NewAccount' }"
            class="text-decoration-none text-primary font-weight-medium"
            >Sign up</router-link
          >
        </div>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { login, resendValidationEmail } from '@/controllers/authController.js';
import { LOGO_HEADER, rules } from '@/helpers';
import { ref } from 'vue';

const errors = ref({ apiError: '', username: '', password: '' });
const showValidationResend = ref<boolean>(false);
const loginForm = ref({ username: '', password: '' });
const isFormValid = ref<boolean>(false);
const showpassword = ref<boolean>(false);

const onSubmit = async () => {
  try {
    showValidationResend.value = false;
    await login(loginForm.value.username, loginForm.value.password);
  } catch (err: unknown) {
    const error = err as { code: number; msg: string };
    if (error.code && error.code == 409) {
      showValidationResend.value = true;
    }
    errors.value.apiError = error.msg;
  }
};

const resendEmail = async () => {
  if (loginForm.value.username) {
    try {
      var results = await resendValidationEmail(loginForm.value.username);
      if (results) {
        errors.value.apiError = '';
        showValidationResend.value = false;
      }
    } catch {}
  }
};
</script>
